'use strict';

var WhatIfResultsDirective = function WhatIfResultsDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/what-if-results.html'),
    controller: 'WhatIfResultsController',
    scope: {
      rule: '=',
      whatIfStatus: '='
    },
    link: function link($scope) {
      $scope.$on('whatIfResults:showModal', function (event, rule) {
        $scope.openModalWindow(rule);
      });
      $scope.$on('grid:rowSelectionChanged', function (event, selectedRows) {
        $scope.onRowSelection(selectedRows);
      });
      $scope.$on('whatIfResults:collapsedGrid', $scope.collapseHandler);
    }
  };
};
WhatIfResultsDirective.$inject = [];
module.exports = WhatIfResultsDirective;